import { useDispatch, useSelector } from "react-redux"; // Redux hooks for dispatching actions and accessing state
import React, { useEffect, useRef, useState } from "react"; // React hooks for managing component lifecycle, state, and refs
import { TABLES } from "../../../../Apis/Tables"; // Import table constants
import { DeleteItemsApi } from "../../../../reduxToolkit/Commons/CommonsApi";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import { UpdateIconsOptions} from "../../../../components/buttons/IconButtons";
import {permissionObj} from "../../../../Helpers/permission";
import TableFunction from "../../../../components/table/TableFunction";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {errorMsg} from "../../../../Apis/functions";
import {SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi"; // Import common API actions

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 *
 * DepartmentApp is responsible for managing department data and associated users.
 * It handles fetching, pagination, sorting, selection, deletion, and other operations.
 */



export const DepartmentApp = () => {
    const dispatch = useDispatch();
    const [addShow, setAddShow] = useState(false);
    const [updateData, setUpdateData] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);
    const [modalDeleteDepartments, setModalDeleteDepartments] = useState(false);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [search, setSearch] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState('');
    const [bodyForExport, setBodyForExport] = useState();
    const [simpleSearch, setSimpleSearch] = useState(false);

    // Define the option constant from imported TABLES
    const option = TABLES.DEPARTMENT;

    // Retrieve various states from Redux store using selectors
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [modified,setModified] = useState(false)
    const [selectedList, setSelectedList] = useState([]);
    const [expandedRowId, setExpandedRowId] = useState(null);

    // Ref for DOM element manipulation
    const elementRef = useRef(null);

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    const renderOptionsMenu = (row,index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle}
                                     menuId={`menu-${row.id}`}>
                    {(DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_UPDATE)) &&
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('update')}
                        click={() => {
                            setAddShow(true);
                            setUpdateData(row);
                            setIsUpdate(true);
                        }}
                        icon={ <UpdateIconsOptions/>}
                    />
                    }
                </DropDownMenuProfile>
            </>
        )
    };

    const columns = [
        {
            field: 'name',
            label: 'name',
        },
    ];

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page: page, size: rowsPerPage, model: option, key: searchElement});
        setBodyForExport(body)
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    }

    const {
        t,
        handleCheckboxChange,
        handleDeleteAll,
        handleMenuToggle,
        handleClose,
        openMenu,
        pagination,
        page,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList:setSelectedList,
        data: searchResults,
        labelRowsPerPage:'department_per_page',
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    /**
     * Deletes selected zones.
     * @param {Array} deleteItem - The list of zone IDs to delete.
     */
    const deleteModal = (deleteItem) => {
        const tableName = option;
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName, body })).then(({payload: {data: { success, code },},}) => {
                if(success){
                    setSelectedList([]);
                    setModified(true);
                }else errorMsg(code)
            },
        );
    };

    /**
     * useEffect hook to adjust CSS custom property based on the element's position.
     * This effect runs once when the elementRef is available.
     */
    useEffect(() => {
        if (elementRef.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 0;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    return {
        DEV,
        t,
        permission,
        searchElement,
        setSearchElement,
        setBodyForExport,
        setSearchResults,
        option,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        setAddShow,
        page,
        setIsUpdate,
        handleCheckboxChange,
        setUpdateData,
        handleDeleteAll,
        addShow,
        isUpdate,
        updateData,
        selectedList,
        deleteModal,
        searchResults,
        columns,
        renderOptionsMenu,
        handleRowExpand,
        rowsPerPage,
        pagination,
        modalDeleteDepartments,
        setModalDeleteDepartments,
        setSelectedList,
        setModified,
        modified
    }
}
